import { Typography, TextField } from '@mui/material';
import { ModalButton } from './ModalButton';
import { GeneralModal } from './GeneralModal';

export const WorkDescModal = (props) => {
  <GeneralModal open={props.open} onClose={props.onClose}>
    <Typography id="modal-modal-title" variant="h6" component="h2">
      Work Description
    </Typography>
    <TextField
      id="outlined-basic"
      label="Enter work description or comments"
      variant="outlined"
    />
    <ModalButton
      primaryClickHandler={props.stopWorkHandler}
      secondaryClickHandler={props.cancelHandler}
      primaryBtnName="Okay"
      secondaryBtnName="Cancel"
    />
  </GeneralModal>;
};
